export function formatCurrency(amountInCents: number, currency = 'AED'): string {
  const amount = amountInCents / 100
  return new Intl.NumberFormat('en-AE', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount)
}

export function formatNumber(value: number): string {
  return new Intl.NumberFormat('en-AE').format(value)
}

export function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString('en-AE', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}

/** First name plus last initial only (e.g. "Jane D.") for privacy-conscious display. */
export function formatPrivateDisplayName(firstName: string, lastName: string): string {
  const trimmedFirst = firstName.trim()
  const lastInitial = lastName.trim()[0]
  if (!lastInitial) return trimmedFirst
  return `${trimmedFirst} ${lastInitial.toUpperCase()}.`
}
